import { useState, useEffect } from 'react';
import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import { useSelector } from 'react-redux';
import { Button } from '@simplywallst/ui-core';
import PageAnchor from '@components/PageAnchor';
import { COMPANY_ABOUT_ANCHOR } from '@/constants/anchors';
import { getViewMode } from '@/redux/location/selectors';
import { ViewMode } from '@/pages/CompanyReport/enum';
import { useDwellTracking } from '@/pages/CompanyReport/components/DwellTrackingProvider';
import { useReportSection } from '@/pages/CompanyReport/components/ReportSectionProvider';
import AboutTheCompanyContent from '../AboutTheCompanyContent';

function AboutTheCompanySection() {
  const { observe } = useDwellTracking();
  const { section } = useReportSection();
  const viewMode = useSelector(getViewMode);
  const [expanded, setExpanded] = useState(false);

  //Auto expand when anchor changes to #about
  useEffect(() => {
    const expandHandler = () => {
      if (window.location.hash === `#${COMPANY_ABOUT_ANCHOR}`)
        setExpanded(true);
    };

    expandHandler();
    window.addEventListener('hashchange', expandHandler);
    return () => window.removeEventListener('hashchange', expandHandler);
  }, [setExpanded]);

  useEffect(() => {
    if (viewMode === ViewMode.Print) setExpanded(true);
  }, [viewMode]);

  //Remove #about anchor on collapse
  const handleToggle = () => {
    if (expanded && window.location.hash === `#${COMPANY_ABOUT_ANCHOR}`) {
      window.history.replaceState(null, document.title, ' ');
    }
    setExpanded(!expanded);
  };

  return (
    <>
      <PageAnchor id={COMPANY_ABOUT_ANCHOR} />
      <Section
        data-cy-id="about-the-company"
        data-section={section}
        ref={observe}
      >
        <AboutTheCompanyContent expanded={expanded} />
        <Button
          displayXsDown="block"
          onClick={handleToggle}
          styleType="loud"
          data-cy-id="company-description-toggle"
        >
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      </Section>
    </>
  );
}
export default AboutTheCompanySection;
